import { processJsonLinesStream } from './processJsonLinesResponse';
import { ResponseValidationError } from '@/@core/models/api/errors';
import { Response } from '@aleph-alpha/lib-http';
import { z } from 'zod';

export async function validateResponseData<T extends z.ZodTypeAny>(
  response: Response<unknown>,
  schema: T
): Promise<z.infer<T>> {
  let responseData = response.data;

  // If responseData is a readable stream, process it
  if (responseData instanceof ReadableStream) {
    responseData = await processJsonLinesStream(responseData);
    if (Array.isArray(responseData)) {
      // Validate each item in the JSONL array
      const responseValidationResults = responseData.map((entry) => schema.safeParse(entry));

      const invalidEntries = responseValidationResults.filter((result) => !result.success);
      if (invalidEntries.length > 0) {
        throw new ResponseValidationError(undefined, {
          cause: invalidEntries.map((entry) => entry.error.issues),
        });
      }

      return responseData as z.infer<T>;
    }
  } else {
    const responseValidationResult = schema.safeParse(responseData);
    if (!responseValidationResult.success) {
      throw new ResponseValidationError(undefined, {
        cause: responseValidationResult.error.issues,
      });
    }

    return responseValidationResult.data as z.infer<T>;
  }

  return responseData as z.infer<T>;
}
